// extracted by mini-css-extract-plugin
export var fadeInAnimation = "StaticLayout-module--fadeInAnimation--3d5d1";
export var hiddenContent = "StaticLayout-module--hiddenContent--2307d";
export var img = "StaticLayout-module--img--54086";
export var picture = "StaticLayout-module--picture--558fe";
export var section = "StaticLayout-module--section--d3c26";